"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getZapLastLiveAt({ last_live_at, }) {
    return last_live_at;
}
exports.default = getZapLastLiveAt;
